import { SET_NETWORK_STATUS } from "../constants";

export const setNetworkStatus = status => dispatch => {
  dispatch({
    type: SET_NETWORK_STATUS,
    payload: status
  });
}